const siteObject = {
	name: 'Status',
	shortname: 'Status',
	href: '/',
	appID: import.meta.env.VITE_ABSTRACT_STATUS_APPID || '',
	baseURL: import.meta.env.VITE_ABSTRACT_STATUS_BASE_URL || window.location.origin,
	idBaseURL: import.meta.env.VITE_ABSTRACT_STATUS_ID_BASE_URL || 'https://id.abstract3d.com',
	accessRole: import.meta.env.VITE_ABSTRACT_STATUS_ACCESS_ROLE || '',
	adminRole: import.meta.env.VITE_ABSTRACT_STATUS_ADMIN_ROLE || 'ABSTRACT_STATUS_ADMIN',
	backend: {
		baseURL: import.meta.env.VITE_ABSTRACT_STATUS_BACKEND_URL || '',
		idBaseURL: import.meta.env.VITE_ABSTRACT_STATUS_ID_BACKEND_URL || 'https://api.id.abstract3d.com',
		api: {
			configuration: '/api/configuration',
			userMe: '/api/user/me',
			userList: '/api/user/list',
			user: '/api/user',
			auditList: '/api/audit/list',

			// Public status page
			statusSummary: '/api/status/summary',
			statusIncidents: '/api/status/incidents',
			statusService: '/api/status/service',

			// Admin: probes
			probe: '/api/probe',
			probeList: '/api/probe/list',

			// Admin: services
			service: '/api/service',
			serviceList: '/api/service/list',
			serviceGroups: '/api/service/groups',

			// Admin: incidents
			incident: '/api/incident',
			incidentList: '/api/incident/list',

			// Admin: alert channels
			alertChannels: '/api/alert/channels',
			alertRules: '/api/alert/rules',

			// Admin: config export/import
			configExport: '/api/config/export',
			configImport: '/api/config/import',

			// Admin: auto-scaling
			scalingGroups: '/api/scaling/groups',
			scalingStatus: '/api/scaling/status'
		}
	}
};

export default siteObject;
